"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useXLDesktopBreakpoint = exports.useTabletBreakpoint = exports.useMobileBreakpoint = exports.useDesktopBreakpoint = exports.useBreakpointName = exports.mediaQuery = exports.getBreakpoint = exports.default = exports.breakpoint = exports.XLDesktopBreakpoint = exports.TabletBreakpoint = exports.MobileBreakpoint = exports.DesktopBreakpoint = void 0;
var _breakpoints = require("../../packages/breakpoints");
const BREAKPOINTS = {
  mobile: 640,
  tablet: 1000,
  desktop: 1800
};
const {
  useMobileBreakpoint,
  useTabletBreakpoint,
  useDesktopBreakpoint,
  useXLDesktopBreakpoint,
  useBreakpointName,
  MobileBreakpoint,
  TabletBreakpoint,
  DesktopBreakpoint,
  XLDesktopBreakpoint,
  mediaQuery
} = (0, _breakpoints.createBreakpoints)(BREAKPOINTS);
exports.mediaQuery = mediaQuery;
exports.XLDesktopBreakpoint = XLDesktopBreakpoint;
exports.DesktopBreakpoint = DesktopBreakpoint;
exports.TabletBreakpoint = TabletBreakpoint;
exports.MobileBreakpoint = MobileBreakpoint;
exports.useBreakpointName = useBreakpointName;
exports.useXLDesktopBreakpoint = useXLDesktopBreakpoint;
exports.useDesktopBreakpoint = useDesktopBreakpoint;
exports.useTabletBreakpoint = useTabletBreakpoint;
exports.useMobileBreakpoint = useMobileBreakpoint;
const getBreakpoint = function (width) {
  const entries = Object.entries(BREAKPOINTS);
  for (let i in entries) {
    const [bp, v] = entries[i];
    if (width <= v) return bp;
  }
  return "xl-desktop";
};
exports.getBreakpoint = getBreakpoint;
var _default = exports.default = mediaQuery;
const breakpoint = exports.breakpoint = mediaQuery;